import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { ArticleGroupService } from '../../service/data/article-group.service';
import { ArticleGroup } from '../../model/article-group';

@Component({
    selector: 'app-article-group-manager',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [StandardCommandHandlerResolver, ArticleGroupService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleGroupMultiSelectManagerComponent extends MultiselectObjectManagerComponentBase<ArticleGroup> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: ArticleGroupService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: StandardCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('ArticleGroup');
    this.title = 'ARTICLE_GROUP.ARTICLE_GROUPS';
    this.preferencesKey = 'rent.article-group.list';
  }
}
